/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group, {GroupHead} from "../../../Components/Group";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import ModalOrgRequest from "../../Modal/ModalOrgNormRequest";
import Prompt from "../../../Components/Prompt";
import {Tool} from "../../../App";
import Resource from "../../../Resource";
import {HospitalOrgNormRequest} from '../../../Server/OrgNormRequest';
import {connect} from 'react-redux';
import Perms from '../../../Perms';
import ModalRequestDeliveryProducts from "../../Modal/ModalRequestDeliveryProducts";

class PageHospitalOrgNormRequests extends Component {
    constructor(props) {
        super(props);

        if (!Perms().BLOOD_BANK_ORG_NORM_REQUESTS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    field: 'wB_Sum',
                    headerName: 'WB',
                    headerTooltip: 'جمع تعداد فرآورده خون کامل',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    cellRenderer: row => row.data.wB_Sum || '-'
                }, {
                    field: 'rbC_Sum',
                    headerName: 'RBC',
                    headerTooltip: 'جمع تعداد فرآورده گلبول قرمز متراکم',
                    cellRenderer: row => row.data.rbC_Sum || '-'
                }, {
                    field: 'lrbC_Sum',
                    headerName: 'LRBC',
                    headerTooltip: 'جمع تعداد فرآورده گلبول قرمز کم لکوسیت',
                    cellRenderer: row => row.data.lrbC_Sum || '-'
                }, {
                    field: 'pediatrictRBC_Sum',
                    headerName: 'PediatrictRBC',
                    headerTooltip: 'جمع تعداد فرآورده اطفال',
                    cellRenderer: row => row.data.pediatrictRBC_Sum || '-'
                }, {
                    field: 'plT_Sum',
                    headerName: 'PLT',
                    headerTooltip: 'جمع تعداد فرآورده پلاکت',
                    cellRenderer: row => row.data.plT_Sum || '-'
                }, {
                    field: 'lrplT_Sum',
                    headerName: 'LRPLT',
                    headerTooltip: 'جمع تعداد فرآورده پلاکت کم لوکسیت',
                    cellRenderer: row => row.data.lrplT_Sum || '-'
                }, {
                    field: 'ffP_Sum',
                    headerName: 'FFP',
                    headerTooltip: 'جمع تعداد فرآورده پلاسمای تازه منجمد',
                    cellRenderer: row => row.data.ffP_Sum || '-'
                }, {
                    field: 'cpP_Sum',
                    headerName: 'CPP',
                    headerTooltip: 'جمع تعداد فرآورده فاقد کرایو',
                    cellRenderer: row => row.data.cpP_Sum || '-'
                }, {
                    field: 'crY_Sum',
                    headerName: 'CRY',
                    headerTooltip: 'جمع تعداد فرآورده کرایو',
                    cellRenderer: row => row.data.crY_Sum || '-'
                }, {
                    field: 'requesterFullName',
                    headerName: 'نام درخواست کننده',
                    headerTooltip: 'نام درخواست کننده'
                }, {
                    field: 'createDateTime',
                    headerName: 'زمان درخواست',
                    headerTooltip: 'زمان درخواست',
                    valueGetter: gridDateTime.bind(this, 'date'),
                    cellRenderer: gridDateTime.bind(this, 'date_time')
                }, {
                    field: 'statusStr',
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state'
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 110,
                    // hide: !(this.Perms().PRINT_SECTION_REQUEST || this.Perms().EDIT_ALL_SECTION_REQUEST || this.Perms().DELETE_SECTION_REQUEST),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        const colors = {61: 'yellow', 22: 'red', 23: 'green'};

                        return <GridStates>
                            <GridState theme={colors[row.data.statusId]}>{row.data.statusStr}</GridState>
                        </GridStates>;
                    },
                    control: row => {
                        return <GridControls>
                            <GridButton type={"button"} theme={'view'} title={'مشاهده درخواست'} onClick={this.view.bind(this, row.data)}/>
                            {[65, 66].includes(row.data.statusId) && <GridButton type={"button"} theme={'green'} title={'لیست فرآورده‌ها'} icon={Resource.IMAGE.PACK.MENU2.WHITE} onClick={this.showProducts.bind(this, row.data)}/>}
                            {/*{Perms().BLOOD_BANK_ORG_NORM_REQUESTS.DELETE && <GridButton type={"button"} theme={'delete'} title={'حذف'} disabled={true} onClick={this.del.bind(this, row.data)}/>}*/}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'مشاهده درخواست',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EYE.BLACK}" alt="">`,
                            action: this.view.bind(this, params.node.data),
                            // disabled: !Perms().BLOOD_BANK_ORG_NORM_REQUESTS.VIEW
                        }, {
                            name: 'لیست فرآورده‌ها',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.MENU2.BLACK}" alt="">`,
                            action: this.showProducts.bind(this, params.node.data),
                            // disabled: !Perms().BLOOD_BANK_ORG_NORM_REQUESTS.UPDATE
                            // }, {
                            //     name: 'حذف درخواست فرآورده',
                            //     icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}" alt="">`,
                            //     action: this.update.bind(this, params.node.data),
                            //     disabled: !Perms().BLOOD_BANK_ORG_NORM_REQUESTS.DELETE
                        },
                            'separator',
                            ...params.defaultItems];
                },
                onRowDoubleClicked: row => {
                    this.view(row.data);
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>نکته:</h3>
                                <p>درخواست فرآورده از سمت بخش بعد از ثبت تنها 72 ساعت در چرخه فعالیت سامانه اعتبار دارد و بعد از آن به حالت منقضی در می آید.</p>
                                <p>جهت اطلاع از مدت زمان باقی مانده اعتبار درخواست در سامانه می توانید به ستون اعتبار درخواست مراجعه کنید.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی بیمار می باشد.</p>
                                <p className={'help-back-red'}>نشان دهنده درخواست از نوع اورژانسی می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={'green'}>عادی</GridState> درخواست فرآورده از نوع عادی می باشد.</p>
                                <p><GridState theme={'red'}>اورژانسی</GridState> درخواست فرآورده از نوع اورژانسی می باشد.</p>
                                <p><GridState theme={'blue'}>تعداد فرآورده آماده</GridState> فرآورده از سمت بانک خون برای درخواست آماده شده است.</p>
                                <p><GridState theme={"yellow"}>در انتظار تایید</GridState> درخواست از سمت بانک خون در حال بررسی می باشد و بایستی منتظر تایید و یا رد درخواست بمانید.</p>
                                <p><GridState theme={'red'}>رد درخواست</GridState> درخواست فرآورده از سمت بانک خون رد شده.</p>
                                <p><GridState theme={'green'}>تایید در خواست</GridState> درخواست فرآورده از سمت بانک خون تایید شده.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'print'} title={'چاپ'}/> در صورت نیاز به چاپ مجدد می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'edit'} title={'ویرایش'}/> درصورت نیاز به ویرایش اطلاعات درخواست قبل از تایید توسط بانک خون می توانید از این طریق اقدام کنید.</p>
                                <p><GridButton theme={'delete'} title={'حذف'}/> درصورت نیاز به حذف درخواست قبل از تایید توسط بانک خون می توانید از این طریق اقدام کنید.</p>
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            button: React.createRef(),
            grid: React.createRef(),
            modalOrgNormRequest: React.createRef(),
            modalRequestDeliveryProducts: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <>
            <Group className={'PageHospitalOrgNormRequests-group mar-10'}>
                <GroupHead title={'درخواست‌های فرآورده از سازمان'}>
                    {Perms().BLOOD_BANK_ORG_NORM_REQUESTS.INSERT && <Button refer={this.ref.button} theme={'blue'} onClick={this.addRequestClickHandler.bind(this)}>ثبت درخواست عادی</Button>}
                </GroupHead>
                <div className="pad-4"/>
                <Grid showFields={false} id={'hospitalOrgNormRequests'} refer={this.ref.grid } {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <Prompt ref={this.ref.prompt}/>
            <ModalOrgRequest refer={this.ref.modalOrgNormRequest} onSuccess={this.updateGrid.bind(this)}/>
            <ModalRequestDeliveryProducts refer={this.ref.modalRequestDeliveryProducts} onClose={this.updateGrid.bind(this)}/>
        </>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        HospitalOrgNormRequest.list()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    addRequestClickHandler() {
        this.ref.modalOrgNormRequest.current.open({}, ModalAction.INSERT);
    }

    del(row, props = {loading: _ => null}) {
    }

    showProducts(row, props = {loading: _ => null}) {
        this.ref.modalRequestDeliveryProducts.current.open({hospitalRequestId: row.hospitalRequestId, ...row}, ModalAction.VIEW);
    }

    update(row, props = {loading: _ => null}) {
    }

    view(data) {
        this.ref.modalOrgNormRequest.current.open(data, ModalAction.VIEW);
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(PageHospitalOrgNormRequests);